import {
  CopyBtn,
  InputSelector as BaseInputSelector,
} from "components/buttons/copy_btn"
import Notifier from "app/notifier"


import I18n from "plugins/i18n-js"


const default_selector = {
  button: ".cell--listings--searches--share--box--url-share",
}


class CopyUrlButtonBluePrint extends CopyBtn {
  constructor(selector: BaseInputSelector){
    const merged_selector = Object.assign({}, default_selector, selector)
    super(merged_selector)
  }

  protected onSuccess(e: ClipboardJS.Event){
    Notifier.showSuccess(I18n.t("concepts.listings.searches.share.notifier.url_copied"), 3000)
    super.onSuccess(e)
  }
}

const Factory = {
  create(selector: BaseInputSelector){
    return new CopyUrlButtonBluePrint(selector)
  },
}

export {
  Factory as default,
  Factory,
}
